export default __webpack_public_path__ + "static/media/Flag_of_Seychelles.05efd200.svg";